<main class="roles-page">
  <header class="landing-header header-publico">
    <div class="logos-header" aria-label="Logos institucionales">
      <img src="assets/img/logo-gobierno.png" alt="Gobierno de Chile" class="logo-gobierno" />
      <img src="assets/img/logo-anid.svg" alt="ANID" class="logo-anid" />
    </div>
  </header>

  <section class="roles-card">
    <h1>Selecci&oacute;n de Roles</h1>
    <p>Selecciona un rol para acceder al inicio correspondiente.</p>

    <div class="roles-grid">
      <a
        *ngFor="let rol of roles"
        class="role-btn"
        [routerLink]="rol.route"
        [queryParams]="{ role: rol.key }"
      >
        {{ rol.label }}
      </a>
    </div>
  </section>
</main>
